import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/app/shared/store/plugins/storage'
import abilityPlugin from '@/app/shared/store/plugins/ability'
import auth from '@/app/authorization/state'
import board from '@/app/board/state'
import dashboardTv from '@/app/dashboard-tv/state'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  plugins: [
    storage({
      // User até 1 módulo
      storedKeys: ['auth/rules', 'auth/token'],
      modules: ['auth'],
      destroyOn: ['DESTROY_RULES']
    }),
    abilityPlugin
  ],
  modules: {
    auth,
    history,
    ...board,
    ...dashboardTv
  },
  strict: debug
})
